import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { Chart } from "react-google-charts";
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function ReportData() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [activeTab, setActiveSection] = useState("ProjectDashboard");
  const [options,setDepartmentData]=useState([])
  const [projectReportAssetsCount,setProjectReportAssetsCount]=useState([])
  

  const Category=[{label:"Projects",value:"projects"},
  {label:"Efficiency",value:"time-based"},
  {label:"Spending By",value:"selected"},
  {label:"Translation Memory",value:"tm"}  
]

const ReportType=[{label:"Closed Project Times",value:"time-closed"},
{label:"Timeline per Project",value:"timeline"},
{label:"Workflow Time Efficiency",value:"workflow-efficiency"},
]

const [selectAll, setSelectAll] = useState(false);
const [selectedOptions, setSelectedOptions] = useState([]);

const handleSelectAll = () => {
  if (!selectAll) {
    setSelectedOptions(options);
  } else {
    setSelectedOptions([]);
  }
  setSelectAll(!selectAll);
};

const handleOptionSelect = (selectedOption) => {
  if (selectedOption.value === "select-all") {
    handleSelectAll();
  } else {
    if (selectedOptions.find((option) => option.value === selectedOption.value)) {
      setSelectedOptions(selectedOptions.filter((option) => option.value !== selectedOption.value));
    } else {
      setSelectedOptions([...selectedOptions, selectedOption]);
    }
  }
};

const selectAllOption = { value: "select-all", label: "Select All" };


const getProjectReportAssetsCount=()=>{
  getAxiosResponse(APIUrls.PROJECT_REPORT_ASSETS_COUNT).then(res=>{ 
         if(res?.data?.data && res?.data?.data?.length > 0){
          let nestedData = res?.data?.data.reduce((acc, curr) => {
            acc.push([curr.value, curr.totalProject, curr.totalAssets]);
            return acc;
          }, []);
          nestedData.unshift(["value","Project","Assets"])
          setProjectReportAssetsCount(nestedData)
         }
  }).catch(err=>{
    handleError(err)
  }) 
}

 const chartoptions = {
  hAxis: { title: "Value", titleTextStyle: { color: "#333" } },
  vAxis: { minValue: 0 },
  chartArea: { width: "50%", height: "70%" },
};


useEffect(()=>{
  getAllDepartment()
  getProjectReportAssetsCount()
},[])

const getAllDepartment=()=>{
   getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED).then(res=>{
          if(res?.data?.data && res?.data?.data?.length > 0){
            const dep=res?.data?.data.map(data=>{
              return {
                label:data?.name,
                value:data?.id,
              }
            })
            setDepartmentData(dep)
          }
   }).catch(err=>{
    handleError(err)
   })
}

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="report-data-page">
             <div className="report-data-filter">
                <div className="filter-content flex show-flex">
                <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block">
                            <label>Category</label>
                            <Select
                                classNamePrefix='cw'
                                className="global-dropdown-select"
                                menuShouldScrollIntoView={false}
                                closeMenuOnSelect={true} 
                                options={Category}
                                defaultValue={{ label: 'Select Category' }}
                            />
                        </div>
                        <div className="global-dropdown-block">
                            <label>Report Type</label>
                            <Select
                                classNamePrefix='cw'
                                className="global-dropdown-select"
                                menuShouldScrollIntoView={false}
                                closeMenuOnSelect={true} 
                                defaultValue={{ label: 'Select Report Type' }}
                                options={ReportType}
                            />
                        </div>
                        <div className="global-dropdown-block">
                            <label>From</label>
                            <Select
                                classNamePrefix='cw'
                                className="global-dropdown-select"
                                menuShouldScrollIntoView={false}
                                closeMenuOnSelect={true} 
                                defaultValue={{ label: 'Select From' }}
                                options={[selectAllOption, ...options]}
                                value={selectedOptions}
                                onChange={(selectedOptions) => {selectedOptions[0].value==="select-all"?handleOptionSelect(selectedOptions[0]):setSelectedOptions(selectedOptions)}}
                                isMulti
                                isClearable={true}
                            />
                        </div>
                        </div>
                    <div className="right-side flex">
                       <button className="dashboard-btn">Run Report</button>
                       <button className="dashboard-btn">Email Report</button>
                       <button className="dashboard-btn">
                        <span className="filter-icon">
                          <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z" fill="#1D4ED8"></path>
                            <path d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z" fill="#1D4ED8"></path>
                            <path d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z" fill="#1D4ED8"></path>
                            <path d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z" fill="#1D4ED8"></path>
                            <path d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z" fill="#1D4ED8"></path>
                            <path d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z" fill="#1D4ED8"></path>
                         </svg>
                        </span> Filters
                       </button>
                    </div>
                </div>
             </div>
              <div className="white-bg mh-550 mar-bot50">
                 <div className="inner-heading flex">
                    <div className="left">
                        <h4>Personal Information</h4>
                    </div>
                    <div className="flex two-col">
                        <button className="dashboard-btn">Change Password</button>
                        <button className="dashboard-btn">Edit</button>
                    </div>
                 </div>
                 <div className="API-tab-content">
                   <div className="API-tab-list">
                     <p className="heading-width-border">
                     Details the efficiency of each step in your workflow in terms of the actual number of days spent relative to planned. Items highlighted in orange and the process where the actual time taken exceeded the original plan.
                     </p>
                    <div className="graph">
                    <Chart
                                            chartType="AreaChart"
                                      data={projectReportAssetsCount}
                                      options={chartoptions}
                                      width="100%"
                                      height="400px"
                                    />
                    </div>
                   </div>
                 </div>
                 <h5 className="heading-width-border">Intial Translation</h5>
                 <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Intial Translation">
                       <tr>
                         <th scope="col">Language Pair</th>
                         <th scope="col">Work: Actual Time Spent</th>
                         <th scope="col">Review: Actual Time Spent</th>
                         <th scope="col">Revision: Actual Time Spent</th>
                       </tr>
                       <tbody>
                         <tr>
                            <td>English (US) - Swedish</td>
                            <td><a href="#">100% of planned</a></td>
                            <td><a href="#">100% of planned</a></td>
                            <td>N/A</td>
                         </tr>
                         <tr>
                            <td>English - Japanese</td>
                            <td><a href="#">100% of planned</a></td>
                            <td><a href="#">100% of planned</a></td>
                            <td>N/A</td>
                         </tr>
                         <tr>
                            <td>English (India) - French (France)</td>
                            <td><a href="#">100% of planned</a></td>
                            <td><a href="#">100% of planned</a></td>
                            <td>N/A</td>
                         </tr>
                       </tbody>
                    </table>
                 </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    
    </div>
  );
}
